/* tslint:disable */

/* eslint-disable */
// @ts-nocheck

/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull pos-online-qa-web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 1
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/implementation/pos-online-qa-web)
 */
import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'posonlineqa';

export const ApiKey: Record<Environment, string> = {
  posonlineqa: '5b8e3596d82f747ac11d0e5a8b8854b2',
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '1',
    branch: 'main',
    source: 'pos-online-qa-web',
    versionId: '54a19833-9c21-46ab-aff2-cd1ffa6833e4',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0',
    },
  },
};

export interface LoadOptionsBase {
  disabled?: boolean;
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment;
  client?: { configuration?: BrowserOptions };
};
export type LoadOptionsWithApiKey = LoadOptionsBase & {
  client: { apiKey: string; configuration?: BrowserOptions };
};
export type LoadOptionsWithClientInstance = LoadOptionsBase & {
  client: { instance: BrowserClient };
};

export type LoadOptions =
  | LoadOptionsWithEnvironment
  | LoadOptionsWithApiKey
  | LoadOptionsWithClientInstance;

export interface ApplicationCreatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  merchant_url?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface CalculatorOpenedProperties {
  merchant_url?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationBasicInfoNextClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationBasicInfoViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationBusinessDetailsNextClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationBusinessDetailsViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationContactReferenceNextClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationContactReferenceViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationCurrentAddressNextClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationCurrentAddressViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationEmploymentDetailsNextClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationEmploymentDetailsViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationEmploymentNextClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationEmploymentViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationFinancialInfoNextClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationFinancialInfoViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationHaveOutstandingDebtClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationKycAdditionalIdNumberNextClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationKycAdditionalIdNumberViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationKycIdSelectionNextClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationKycIdSelectionSecondaryNextClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationKycIdSelectionViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationKycMainIdNumberNextClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationKycMainIdNumberViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationKycNoPrimaryIdClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationPermanentAddressDiffersFromCurrentClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationPermanentAddressNextClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationPermanentAddressViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationPersonalDetailsNextClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonApplicationPersonalDetailsViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonBlockActiveApplicationViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonBlockActiveLoanViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonBlockCooldownViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonBlockInvalidPhoneViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonBlockOrderExpiredProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonBlockSubmittedApplicationViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonRedirectToAppClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonRedirectToAppViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonScoringRejectedViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface PonScoringRejectedWhyClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface WebApplicationFinishedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id?: string;
  merchant_url?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export class ApplicationCreated implements BaseEvent {
  event_type = 'application_created';

  constructor(public event_properties: ApplicationCreatedProperties) {
    this.event_properties = event_properties;
  }
}

export class CalculatorOpened implements BaseEvent {
  event_type = 'calculator_opened';

  constructor(public event_properties: CalculatorOpenedProperties) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationBasicInfoNextClick implements BaseEvent {
  event_type = 'pon_application_basic_info_next_click';

  constructor(
    public event_properties: PonApplicationBasicInfoNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationBasicInfoView implements BaseEvent {
  event_type = 'pon_application_basic_info_view';

  constructor(public event_properties: PonApplicationBasicInfoViewProperties) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationBusinessDetailsNextClick implements BaseEvent {
  event_type = 'pon_application_business_details_next_click';

  constructor(
    public event_properties: PonApplicationBusinessDetailsNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationBusinessDetailsView implements BaseEvent {
  event_type = 'pon_application_business_details_view';

  constructor(
    public event_properties: PonApplicationBusinessDetailsViewProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationContactReferenceNextClick implements BaseEvent {
  event_type = 'pon_application_contact_reference_next_click';

  constructor(
    public event_properties: PonApplicationContactReferenceNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationContactReferenceView implements BaseEvent {
  event_type = 'pon_application_contact_reference_view';

  constructor(
    public event_properties: PonApplicationContactReferenceViewProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationCurrentAddressNextClick implements BaseEvent {
  event_type = 'pon_application_current_address_next_click';

  constructor(
    public event_properties: PonApplicationCurrentAddressNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationCurrentAddressView implements BaseEvent {
  event_type = 'pon_application_current_address_view';

  constructor(
    public event_properties: PonApplicationCurrentAddressViewProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationEmploymentDetailsNextClick implements BaseEvent {
  event_type = 'pon_application_employment_details_next_click';

  constructor(
    public event_properties: PonApplicationEmploymentDetailsNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationEmploymentDetailsView implements BaseEvent {
  event_type = 'pon_application_employment_details_view';

  constructor(
    public event_properties: PonApplicationEmploymentDetailsViewProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationEmploymentNextClick implements BaseEvent {
  event_type = 'pon_application_employment_next_click';

  constructor(
    public event_properties: PonApplicationEmploymentNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationEmploymentView implements BaseEvent {
  event_type = 'pon_application_employment_view';

  constructor(public event_properties: PonApplicationEmploymentViewProperties) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationFinancialInfoNextClick implements BaseEvent {
  event_type = 'pon_application_financial_info_next_click';

  constructor(
    public event_properties: PonApplicationFinancialInfoNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationFinancialInfoView implements BaseEvent {
  event_type = 'pon_application_financial_info_view';

  constructor(
    public event_properties: PonApplicationFinancialInfoViewProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationHaveOutstandingDebtClick implements BaseEvent {
  event_type = 'pon_application_have_outstanding_debt_click';

  constructor(
    public event_properties: PonApplicationHaveOutstandingDebtClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationKycAdditionalIdNumberNextClick implements BaseEvent {
  event_type = 'pon_application_kyc_additional_id_number_next_click';

  constructor(
    public event_properties: PonApplicationKycAdditionalIdNumberNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationKycAdditionalIdNumberView implements BaseEvent {
  event_type = 'pon_application_kyc_additional_id_number_view';

  constructor(
    public event_properties: PonApplicationKycAdditionalIdNumberViewProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationKycIdSelectionNextClick implements BaseEvent {
  event_type = 'pon_application_kyc_id_selection_next_click';

  constructor(
    public event_properties: PonApplicationKycIdSelectionNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationKycIdSelectionSecondaryNextClick
  implements BaseEvent
{
  event_type = 'pon_application_kyc_id_selection_secondary_next_click';

  constructor(
    public event_properties: PonApplicationKycIdSelectionSecondaryNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationKycIdSelectionView implements BaseEvent {
  event_type = 'pon_application_kyc_id_selection_view';

  constructor(
    public event_properties: PonApplicationKycIdSelectionViewProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationKycMainIdNumberNextClick implements BaseEvent {
  event_type = 'pon_application_kyc_main_id_number_next_click';

  constructor(
    public event_properties: PonApplicationKycMainIdNumberNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationKycMainIdNumberView implements BaseEvent {
  event_type = 'pon_application_kyc_main_id_number_view';

  constructor(
    public event_properties: PonApplicationKycMainIdNumberViewProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationKycNoPrimaryIdClick implements BaseEvent {
  event_type = 'pon_application_kyc_no_primary_id_click';

  constructor(
    public event_properties: PonApplicationKycNoPrimaryIdClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationPermanentAddressDiffersFromCurrentClick
  implements BaseEvent
{
  event_type = 'pon_application_permanent_address_differs_from_current_click';

  constructor(
    public event_properties: PonApplicationPermanentAddressDiffersFromCurrentClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationPermanentAddressNextClick implements BaseEvent {
  event_type = 'pon_application_permanent_address_next_click';

  constructor(
    public event_properties: PonApplicationPermanentAddressNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationPermanentAddressView implements BaseEvent {
  event_type = 'pon_application_permanent_address_view';

  constructor(
    public event_properties: PonApplicationPermanentAddressViewProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationPersonalDetailsNextClick implements BaseEvent {
  event_type = 'pon_application_personal_details_next_click';

  constructor(
    public event_properties: PonApplicationPersonalDetailsNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonApplicationPersonalDetailsView implements BaseEvent {
  event_type = 'pon_application_personal_details_view';

  constructor(
    public event_properties: PonApplicationPersonalDetailsViewProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonBlockActiveApplicationView implements BaseEvent {
  event_type = 'pon_block_active_application_view';

  constructor(
    public event_properties: PonBlockActiveApplicationViewProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonBlockActiveLoanView implements BaseEvent {
  event_type = 'pon_block_active_loan_view';

  constructor(public event_properties: PonBlockActiveLoanViewProperties) {
    this.event_properties = event_properties;
  }
}

export class PonBlockCooldownView implements BaseEvent {
  event_type = 'pon_block_cooldown_view';

  constructor(public event_properties: PonBlockCooldownViewProperties) {
    this.event_properties = event_properties;
  }
}

export class PonBlockInvalidPhoneView implements BaseEvent {
  event_type = 'pon_block_invalid_phone_view';

  constructor(public event_properties: PonBlockInvalidPhoneViewProperties) {
    this.event_properties = event_properties;
  }
}

export class PonBlockOrderExpired implements BaseEvent {
  event_type = 'pon_block_order_expired';

  constructor(public event_properties: PonBlockOrderExpiredProperties) {
    this.event_properties = event_properties;
  }
}

export class PonBlockSubmittedApplicationView implements BaseEvent {
  event_type = 'pon_block_submitted_application_view';

  constructor(
    public event_properties: PonBlockSubmittedApplicationViewProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PonRedirectToAppClick implements BaseEvent {
  event_type = 'pon_redirect_to_app_click';

  constructor(public event_properties: PonRedirectToAppClickProperties) {
    this.event_properties = event_properties;
  }
}

export class PonRedirectToAppView implements BaseEvent {
  event_type = 'pon_redirect_to_app_view';

  constructor(public event_properties: PonRedirectToAppViewProperties) {
    this.event_properties = event_properties;
  }
}

export class PonScoringRejectedView implements BaseEvent {
  event_type = 'pon_scoring_rejected_view';

  constructor(public event_properties: PonScoringRejectedViewProperties) {
    this.event_properties = event_properties;
  }
}

export class PonScoringRejectedWhyClick implements BaseEvent {
  event_type = 'pon_scoring_rejected_why_click';

  constructor(public event_properties: PonScoringRejectedWhyClickProperties) {
    this.event_properties = event_properties;
  }
}

export class WebApplicationFinished implements BaseEvent {
  event_type = 'web_application_finished';

  constructor(public event_properties: WebApplicationFinishedProperties) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * application_created
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/application_created)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  applicationCreated(
    properties: ApplicationCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationCreated(properties), options);
  }

  /**
   * calculator_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/calculator_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. merchant_url)
   * @param options Amplitude event options.
   */
  calculatorOpened(
    properties: CalculatorOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CalculatorOpened(properties), options);
  }

  /**
   * pon_application_basic_info_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_basic_info_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationBasicInfoNextClick(
    properties: PonApplicationBasicInfoNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationBasicInfoNextClick(properties), options);
  }

  /**
   * pon_application_basic_info_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_basic_info_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationBasicInfoView(
    properties: PonApplicationBasicInfoViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationBasicInfoView(properties), options);
  }

  /**
   * pon_application_business_details_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_business_details_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationBusinessDetailsNextClick(
    properties: PonApplicationBusinessDetailsNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationBusinessDetailsNextClick(properties), options);
  }

  /**
   * pon_application_business_details_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_business_details_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationBusinessDetailsView(
    properties: PonApplicationBusinessDetailsViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationBusinessDetailsView(properties), options);
  }

  /**
   * pon_application_contact_reference_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_contact_reference_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationContactReferenceNextClick(
    properties: PonApplicationContactReferenceNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationContactReferenceNextClick(properties), options);
  }

  /**
   * pon_application_contact_reference_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_contact_reference_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationContactReferenceView(
    properties: PonApplicationContactReferenceViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationContactReferenceView(properties), options);
  }

  /**
   * pon_application_current_address_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_current_address_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationCurrentAddressNextClick(
    properties: PonApplicationCurrentAddressNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationCurrentAddressNextClick(properties), options);
  }

  /**
   * pon_application_current_address_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_current_address_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationCurrentAddressView(
    properties: PonApplicationCurrentAddressViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationCurrentAddressView(properties), options);
  }

  /**
   * pon_application_employment_details_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_employment_details_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationEmploymentDetailsNextClick(
    properties: PonApplicationEmploymentDetailsNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationEmploymentDetailsNextClick(properties), options);
  }

  /**
   * pon_application_employment_details_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_employment_details_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationEmploymentDetailsView(
    properties: PonApplicationEmploymentDetailsViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationEmploymentDetailsView(properties), options);
  }

  /**
   * pon_application_employment_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_employment_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationEmploymentNextClick(
    properties: PonApplicationEmploymentNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationEmploymentNextClick(properties), options);
  }

  /**
   * pon_application_employment_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_employment_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationEmploymentView(
    properties: PonApplicationEmploymentViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationEmploymentView(properties), options);
  }

  /**
   * pon_application_financial_info_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_financial_info_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationFinancialInfoNextClick(
    properties: PonApplicationFinancialInfoNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationFinancialInfoNextClick(properties), options);
  }

  /**
   * pon_application_financial_info_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_financial_info_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationFinancialInfoView(
    properties: PonApplicationFinancialInfoViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationFinancialInfoView(properties), options);
  }

  /**
   * pon_application_have_outstanding_debt_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_have_outstanding_debt_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationHaveOutstandingDebtClick(
    properties: PonApplicationHaveOutstandingDebtClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationHaveOutstandingDebtClick(properties), options);
  }

  /**
   * pon_application_kyc_additional_id_number_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_kyc_additional_id_number_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationKycAdditionalIdNumberNextClick(
    properties: PonApplicationKycAdditionalIdNumberNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationKycAdditionalIdNumberNextClick(properties), options);
  }

  /**
   * pon_application_kyc_additional_id_number_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_kyc_additional_id_number_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationKycAdditionalIdNumberView(
    properties: PonApplicationKycAdditionalIdNumberViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationKycAdditionalIdNumberView(properties), options);
  }

  /**
   * pon_application_kyc_id_selection_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_kyc_id_selection_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationKycIdSelectionNextClick(
    properties: PonApplicationKycIdSelectionNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationKycIdSelectionNextClick(properties), options);
  }

  /**
   * pon_application_kyc_id_selection_secondary_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_kyc_id_selection_secondary_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationKycIdSelectionSecondaryNextClick(
    properties: PonApplicationKycIdSelectionSecondaryNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationKycIdSelectionSecondaryNextClick(properties), options);
  }

  /**
   * pon_application_kyc_id_selection_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_kyc_id_selection_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationKycIdSelectionView(
    properties: PonApplicationKycIdSelectionViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationKycIdSelectionView(properties), options);
  }

  /**
   * pon_application_kyc_main_id_number_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_kyc_main_id_number_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationKycMainIdNumberNextClick(
    properties: PonApplicationKycMainIdNumberNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationKycMainIdNumberNextClick(properties), options);
  }

  /**
   * pon_application_kyc_main_id_number_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_kyc_main_id_number_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationKycMainIdNumberView(
    properties: PonApplicationKycMainIdNumberViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationKycMainIdNumberView(properties), options);
  }

  /**
   * pon_application_kyc_no_primary_id_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_kyc_no_primary_id_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationKycNoPrimaryIdClick(
    properties: PonApplicationKycNoPrimaryIdClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationKycNoPrimaryIdClick(properties), options);
  }

  /**
   * pon_application_permanent_address_differs_from_current_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_permanent_address_differs_from_current_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationPermanentAddressDiffersFromCurrentClick(
    properties: PonApplicationPermanentAddressDiffersFromCurrentClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationPermanentAddressDiffersFromCurrentClick(properties), options);
  }

  /**
   * pon_application_permanent_address_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_permanent_address_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationPermanentAddressNextClick(
    properties: PonApplicationPermanentAddressNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationPermanentAddressNextClick(properties), options);
  }

  /**
   * pon_application_permanent_address_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_permanent_address_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationPermanentAddressView(
    properties: PonApplicationPermanentAddressViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationPermanentAddressView(properties), options);
  }

  /**
   * pon_application_personal_details_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_personal_details_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationPersonalDetailsNextClick(
    properties: PonApplicationPersonalDetailsNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationPersonalDetailsNextClick(properties), options);
  }

  /**
   * pon_application_personal_details_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_application_personal_details_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponApplicationPersonalDetailsView(
    properties: PonApplicationPersonalDetailsViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonApplicationPersonalDetailsView(properties), options);
  }

  /**
   * pon_block_active_application_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_block_active_application_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. wuid)
   * @param options Amplitude event options.
   */
  ponBlockActiveApplicationView(
    properties: PonBlockActiveApplicationViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonBlockActiveApplicationView(properties), options);
  }

  /**
   * pon_block_active_loan_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_block_active_loan_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. wuid)
   * @param options Amplitude event options.
   */
  ponBlockActiveLoanView(
    properties: PonBlockActiveLoanViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonBlockActiveLoanView(properties), options);
  }

  /**
   * pon_block_cooldown_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_block_cooldown_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. wuid)
   * @param options Amplitude event options.
   */
  ponBlockCooldownView(
    properties: PonBlockCooldownViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonBlockCooldownView(properties), options);
  }

  /**
   * pon_block_invalid_phone_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_block_invalid_phone_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. wuid)
   * @param options Amplitude event options.
   */
  ponBlockInvalidPhoneView(
    properties: PonBlockInvalidPhoneViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonBlockInvalidPhoneView(properties), options);
  }

  /**
   * pon_block_order_expired
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_block_order_expired)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. wuid)
   * @param options Amplitude event options.
   */
  ponBlockOrderExpired(
    properties: PonBlockOrderExpiredProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonBlockOrderExpired(properties), options);
  }

  /**
   * pon_block_submitted_application_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_block_submitted_application_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. wuid)
   * @param options Amplitude event options.
   */
  ponBlockSubmittedApplicationView(
    properties: PonBlockSubmittedApplicationViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonBlockSubmittedApplicationView(properties), options);
  }

  /**
   * pon_redirect_to_app_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_redirect_to_app_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponRedirectToAppClick(
    properties: PonRedirectToAppClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonRedirectToAppClick(properties), options);
  }

  /**
   * pon_redirect_to_app_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_redirect_to_app_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponRedirectToAppView(
    properties: PonRedirectToAppViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonRedirectToAppView(properties), options);
  }

  /**
   * pon_scoring_rejected_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_scoring_rejected_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponScoringRejectedView(
    properties: PonScoringRejectedViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonScoringRejectedView(properties), options);
  }

  /**
   * pon_scoring_rejected_why_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/pon_scoring_rejected_why_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  ponScoringRejectedWhyClick(
    properties: PonScoringRejectedWhyClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PonScoringRejectedWhyClick(properties), options);
  }

  /**
   * web_application_finished
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/web_application_finished)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  webApplicationFinished(
    properties: WebApplicationFinishedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WebApplicationFinished(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
